<template>
  <v-card>
    <!-- <v-card-title>
      <div class="headline">{{ title }}</div>
    </v-card-title> -->
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon v-if="newBlkGrp">mdi-plus</v-icon>
      <v-icon v-else-if="queryBlkGrp">mdi-magnify</v-icon>
      <v-icon v-else>mdi-pencil</v-icon>
      <v-toolbar-title v-if="newBlkGrp">Create New Block Group</v-toolbar-title>
      <v-toolbar-title v-else-if="queryBlkGrp">Query Block Group</v-toolbar-title>
      <v-toolbar-title v-else>Edit Block Group</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <message :messages="messages"></message>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs6 v-if="newBlkGrp">
            <v-autocomplete
              :items="accmTypeList"
              v-model="blkGrpForm.accmType"
              :label="labels.accmType"
              item-text="label"
              item-value="value"
              data-vv-name="accmType"
              :data-vv-as="labels.accmType"
              :error-messages="errors.collect('accmType')"
              @change="setValue()"
              v-validate="'required'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.accmType }}</v-subheader>
            <div class="queryValue">{{ getDesc(blkGrpForm.accmType) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newBlkGrp">
            <v-checkbox v-model="blkGrpForm.blkGrpAe" :label="labels.blkGrpAe" data-vv-name="blkGrpAe" :data-vv-as="labels.blkGrpAe"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.blkGrpAe }}</v-subheader>
            <div class="queryValue">{{ blkGrpForm.blkGrpAe }}</div>
          </v-flex>
          <v-flex xs6 v-if="newBlkGrp">
            <v-text-field
              v-model="blkGrpForm.blkGrp"
              :label="labels.blkGrp"
              :error-messages="errors.collect('blkGrp')"
              data-vv-name="blkGrp"
              :data-vv-as="labels.blkGrp"
              :disabled="ae()"
              v-validate="'required|max:10'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.blkGrp }}</v-subheader>
            <div class="queryValue">{{ blkGrpForm.blkGrp }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 v-if="!queryBlkGrp">
            <v-text-field
              v-model="blkGrpForm.blkGrpDescS"
              :label="labels.blkGrpDescS"
              :error-messages="errors.collect('blkGrpDescS')"
              data-vv-name="blkGrpDescS"
              :data-vv-as="labels.blkGrpDescS"
              v-validate="'required|max:100'"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 v-else>
            <v-subheader class="queryLabel">{{ labels.blkGrpDescS }}</v-subheader>
            <div class="queryValue">{{ blkGrpForm.blkGrpDescS }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 v-if="!queryBlkGrp">
            <v-text-field
              v-model="blkGrpForm.blkGrpDescL"
              :label="labels.blkGrpDescL"
              :error-messages="errors.collect('blkGrpDescL')"
              data-vv-name="blkGrpDescL"
              :data-vv-as="labels.blkGrpDescL"
              v-validate="'required|max:200'"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 v-else>
            <v-subheader class="queryLabel">{{ labels.blkGrpDescL }}</v-subheader>
            <div class="queryValue">{{ blkGrpForm.blkGrpDescL }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 v-if="!queryBlkGrp">
            <v-text-field
              v-model="blkGrpForm.remark"
              :label="labels.remark"
              :error-messages="errors.collect('remark')"
              data-vv-name="remark"
              :data-vv-as="labels.remark"
              v-validate="'max:1000'"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 v-else>
            <v-subheader class="queryLabel">{{ labels.remark }}</v-subheader>
            <div class="queryValue">{{ blkGrpForm.remark }}</div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ blkGrpForm.createdName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(blkGrpForm.createdDate) }}</div>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="!newBlkGrp">
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ blkGrpForm.modifiedName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(blkGrpForm.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="close()">Cancel</v-btn>
      <v-btn color="primary" v-if="!queryBlkGrp" text @click.native="doSave">{{ newBlkGrp ? 'Save' : 'Update' }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'

export default {
  props: {
    blkGrpForm: Object,
    mode: String
  },
  data() {
    return {
      title: '',
      labels: {
        accmType: 'Accumulation Type',
        blkGrp: '-',
        blkGrpAe: 'Block Group AE',
        blkGrpDescS: 'Short Description',
        blkGrpDescL: 'Long Description',
        remark: 'Remark',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      newBlkGrp: false,
      queryBlkGrp: false,
      accmTypeList: [],
      submitting: false
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  watch: {
    mode: function (value) {
      this.doInit()
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      if (this.mode === 'new') {
        this.doInitForm()
        this.newBlkGrp = true
        this.queryBlkGrp = false
        this.title = 'New Block Group'
      } else {
        this.setValue()
        if (this.mode === 'edit') {
          this.newBlkGrp = false
          this.queryBlkGrp = false
          this.title = 'Review Block Group'
        } else {
          this.newBlkGrp = false
          this.queryBlkGrp = true
          this.title = 'Query Block Group'
        }
      }
    },
    getDesc(id) {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === id) {
          return this.accmTypeList[i].label
        }
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    ae() {
      if (this.blkGrpForm.blkGrpAe) {
        this.setBlkGrp()
        return true
      } else {
        return false
      }
    },
    doInitForm() {
      this.resetMessages()
      this.blkGrpForm.accmType = null
      this.blkGrpForm.blkGrp = null
      this.blkGrpForm.blkGrpAe = false
      this.blkGrpForm.blkGrpDescS = null
      this.blkGrpForm.blkGrpDescL = null
      this.blkGrpForm.remark = null
      this.blkGrpForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.blkGrpForm.createdDate = new Date()

      this.labels.blkGrp = ''
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType,
              blkGrpLblS: accmType.blkGrpLblS,
              defBlkGrpAe: accmType.defBlkGrpAe,
              nxtBlkGrpSeq: accmType.nxtBlkGrpSeq
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    setValue() {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === this.blkGrpForm.accmType) {
          this.labels.blkGrp = this.accmTypeList[i].blkGrpLblS
          if (this.newBlkGrp) {
            this.blkGrpForm.blkGrpAe = this.accmTypeList[i].defBlkGrpAe
            if (this.blkGrpForm.blkGrpAe) {
              this.blkGrpForm.blkGrp = this.accmTypeList[i].nxtBlkGrpSeq.toString().padStart(8, '0')
            } else {
              this.blkGrpForm.blkGrp = null
            }
          }
        }
      }
    },
    setBlkGrp() {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === this.blkGrpForm.accmType) {
          if (this.blkGrpForm.blkGrpAe) {
            this.blkGrpForm.blkGrp = this.accmTypeList[i].nxtBlkGrpSeq.toString().padStart(8, '0')
          } else {
            this.blkGrpForm.blkGrp = null
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newBlkGrp) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createBlkGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.blkGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateBlkGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.blkGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    close() {
      this.doInitForm()
      this.$emit('close')
    }
  },
  async created() {
    await this.getAccmTypeList()
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>
